module.exports = __webpack_public_path__ + "img/ICONE-TEL.0e39a9cc.svg";